import React, { useState, useEffect } from "react";
import { Link } from "react-scroll";
import { FaGithub } from "react-icons/fa";

export default function Navbar() {
  const [activeSection, setActiveSection] = useState("home");

  // Handle scroll to update active section
  const handleScroll = () => {
    const sections = ["home", "about", "services", "projects"];
    let current = sections[0];

    for (const section of sections) {
      const element = document.getElementById(section);
      if (element) {
        const rect = element.getBoundingClientRect();
        if (rect.top <= 100) {
          current = section;
        }
      }
    }
    setActiveSection(current);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav className="fixed top-0 left-0 right-0 flex justify-between items-center px-4 py-3 border-b border-gray-800 bg-black/90 backdrop-blur-sm z-50">
      <div className="font-bold text-sm text-white">PRICELESS</div>
      <div className="space-x-6 hidden md:flex text-sm">
        {["home", "about", "services", "projects"].map((section) => (
          <Link
            key={section}
            to={section}
            spy={true}
            smooth={true}
            duration={500}
            offset={-70}
            className="relative cursor-pointer capitalize hover:text-white text-gray-300 transition-colors"
            onSetActive={() => setActiveSection(section)}
          >
            {section}
            <span 
              className={`absolute left-0 right-0 bottom-[-3px] h-[1px] bg-white transform origin-left transition-transform duration-300 ${
                activeSection === section ? 'scale-x-100' : 'scale-x-0'
              }`}
            />
          </Link>
        ))}
      </div>
      <a
        href="https://github.com/Pjewels"
        target="_blank"
        rel="noopener noreferrer"
        className="relative group px-3 py-1.5 bg-transparent border border-white text-white rounded text-sm overflow-hidden transition-all duration-300 hover:text-black"
      >
        <span className="relative z-10 flex items-center gap-1.5">
          <FaGithub className="text-base" />
          GitHub
        </span>
        <div className="absolute inset-0 bg-white transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left" />
      </a>
    </nav>
  );
}
